/**
 * 旁白卡片组件
 */

import React from 'react';
import { Heart } from 'lucide-react';
import type { ChatMessage } from '../../../types';

interface NarrativeCardProps {
  message: ChatMessage;
}

export const NarrativeCard: React.FC<NarrativeCardProps> = React.memo(({ message }) => {
  const isGood = (message.cpChange || 0) >= 0;
  return (
    <div className="flex justify-center my-4">
      <div className="bg-white rounded-2xl shadow-md border border-[#E5E0D8] px-4 py-3 max-w-[85%]">
        <div className="flex justify-center mb-2">
          <span
            className={`px-3 py-1 rounded-full text-xs font-bold ${isGood
                ? 'bg-[#FFE0E0] text-[#FF6B6B]'
                : 'bg-[#E0F0FF] text-[#6BB8FF]'
              }`}
          >
            <Heart size={12} className="inline mr-1" /> CP {isGood ? '+' : ''}{message.cpChange}
          </span>
        </div>
        <p className="text-sm text-[#6B7280] text-center leading-relaxed">
          {message.text}
        </p>
      </div>
    </div>
  );
});

NarrativeCard.displayName = 'NarrativeCard';
